import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual, slice } from 'lodash';

import SuggestionListItem from 'commons-forms/components/InputAutoComplete/SuggestionList/SuggestionListItem.jsx';

import 'commons-forms/components/InputAutoComplete/SuggestionList/SuggestionList.scss';

class SuggestionList extends Component {
    constructor(props) {
        super(props);
        this.listRef = React.createRef();
    }

    componentDidMount() {
        this.setListPosition();
    }

    shouldComponentUpdate(nextProps) {
        const { items, activeElementIndex } = this.props;
        return !isEqual(nextProps.items, items) || nextProps.activeElementIndex !== activeElementIndex;
    }

    // checks if list has space at the bottom to be displayed,
    // if not, will position it from the bottom of the input
    setListPosition() {
        const listLimit = this.listRef?.current?.offsetHeight || 350;
        const pageHeight = document.body.scrollHeight - window.scrollY;
        const listPosition = this.listRef?.current?.getBoundingClientRect();

        if (pageHeight - listPosition?.top < listLimit) {
            this.listRef.current.classList.add('bottom');
        }
    }

    render() {
        const { activeElementIndex, items, onSelectedOption, suggestionsToDisplay } = this.props;

        const suggestionItems = slice(items, 0, suggestionsToDisplay).map((item, index) => {
            return (
                <SuggestionListItem
                    key={item.value}
                    value={item.value}
                    isActive={index === activeElementIndex}
                    onItemClick={onSelectedOption}
                />
            );
        });

        return (
            <ul ref={this.listRef} className="SuggestionList">
                {suggestionItems}
            </ul>
        );
    }
}

SuggestionList.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
        }).isRequired
    ).isRequired,
    onSelectedOption: PropTypes.func.isRequired,
    activeElementIndex: PropTypes.number.isRequired,
    suggestionsToDisplay: PropTypes.number.isRequired,
};

SuggestionList.displayName = 'SuggestionList';

export default SuggestionList;
